import axios from "../axios";

const ManageJobsFlag = "MANAGE_JOBS/FLAG";
const ManageJobsList = "MANAGE_JOBS/LIST";
const ManageJobsFetchTypeCollection = "MANAGE_JOBS/FETCH_TYPE_COLLECTION";
const ManageJobsChangePageNo = "MANAGE_JOBS/CHANGE_PAGE_NO";

// 默认数据
const defaultState = {
  FLAG_LOADING: false, // 拉取职位开关
  list: [], // 管理职位列表
  current: 1, // 分页器 - 当前页码
  totalCount: 0, // 总职位数
  typeCollection: [] // 职位类型集合
};

/*
 * Reducer
 */
export default function Reducer(state = defaultState, action) {
  switch (action.type) {
    case ManageJobsList:
      return {
        ...state,
        list: action.payload.list,
        totalCount: action.payload.totalCount
      };
    case ManageJobsFlag:
      return {
        ...state,
        FLAG_LOADING: !state.FLAG_LOADING
      };
    case ManageJobsFetchTypeCollection:
      return {
        ...state,
        typeCollection: action.payload
      };
    case ManageJobsChangePageNo:
      return {
        ...state,
        current: action.payload
      };
    default:
      return state;
  }
}

/*
 * CreateAction
 */

/**
 * [拉取列表数据]
 * @param  {[String]} url [请求地址]
 */
export const createFetchDataAction = function(url) {
  return dispatch => {
    dispatch({
      type: ManageJobsFlag
    });
    let API = url ? `/api/findJobs?${url}` : "/api/findJobs";
    axios
      .get(API)
      .then(({ data }) => {
        dispatch({
          type: ManageJobsList,
          payload: {
            list: data.list,
            totalCount: data.totalCount
          }
        });
      })
      .then(() => {
        dispatch({
          type: ManageJobsFlag
        });
      })
      .catch(error => {
        console.log(error);
      });
  };
};

// 拉取职位类型集合
export const createFetchTypeCollection = () => dispatch => {
  axios.get("/api/typeCollection").then(({ data }) => {
    dispatch({
      type: ManageJobsFetchTypeCollection,
      payload: data.types
    });
  });
};

/*
 * 设置当前页码
 */
export const createChangePageNoAction = current => dispatch => {
  dispatch({
    type: ManageJobsChangePageNo,
    payload: current
  });
};



// WEBPACK FOOTER //
// ./src/redux/ManageJobs.jsx